import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { brandResponse } from "../_model/brand/brand-response";
import { UserService } from "./user.service";
import { ClientResponse } from '../_model/client-response/client-response';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  baseUrl = '/brandList';
  //  baseUrl = '/api/gateway/v1/brandList';
  

  constructor(private http: HttpClient, private userService: UserService) { }

  getBrandLists(): Observable<brandResponse> {
    // console.log("brandList url",this.userService.getBaseUrl() + this.baseUrl)
    return this.http.get<brandResponse>(this.userService.getBaseUrl() + this.baseUrl);
  }
  


  getClientsByBrandName(brand: string,fmSystemId: string): Observable<ClientResponse> {
    // console.log(this.userService.getBaseUrl() + '/clients' + '/fmSystem/' + fmSystemId + '/brandName/' + brand)
    return this.http.get<ClientResponse>(this.userService.getBaseUrl() + '/clients' + '/fmSystem/' + fmSystemId + '/brandName/' + brand);
    // return this.http.get<ClientResponse>(this.userService.getBaseUrl() + '/clients' + '/fmSystem/' + fmSystemId);
  }


}


